import { DUPLEXER_CHANNEL_NAME_PREFIX } from './constants';
export const createDuplexerChannelName = suffix => {
  return `${DUPLEXER_CHANNEL_NAME_PREFIX}${suffix}`;
};
//# sourceMappingURL=utils.js.map